import React from "react";

// ===============================
// CONSTANTS
// ===============================
const OVERVIEW_STAT_CARDS = [
  {
    key: "totalProjects",
    label: "Total Proyek",
    valueKey: "projects.total",
    bgColor: "bg-primary/10",
    textColor: "text-primary-dark",
  },
  {
    key: "totalExcavations",
    label: "Total Galian",
    valueKey: "excavations.total",
    bgColor: "bg-orange-50",
    textColor: "text-orange-700",
  },
  {
    key: "inProgress",
    label: "Berjalan",
    valueKey: "inProgress",
    bgColor: "bg-blue-50",
    textColor: "text-blue-700",
  },
];

// ===============================
// COMPONENT
// ===============================
const StatisticsCards = ({ stats }) => {
  // Calculate aggregated values
  const totalProjects = stats?.projects?.total || 0;
  const totalExcavations = stats?.excavations?.total || 0;
  const totalInProgress =
    (stats?.projects?.["in-progress"] || 0) +
    (stats?.excavations?.["in-progress"] || 0);

  const getValue = (valueKey) => {
    switch (valueKey) {
      case "projects.total":
        return totalProjects;
      case "excavations.total":
        return totalExcavations;
      case "inProgress":
        return totalInProgress;
      default:
        return 0;
    }
  };

  return (
    <div className="grid grid-cols-3 gap-3">
      {OVERVIEW_STAT_CARDS.map(
        ({ key, label, valueKey, bgColor, textColor }) => (
          <div
            key={key}
            className={`${bgColor} rounded-xl p-4 text-center border border-white/20 shadow-sm hover:shadow-md transition-all duration-200`}
          >
            <div className={`text-xl font-bold ${textColor} mb-1`}>
              {getValue(valueKey)}
            </div>
            <div className="text-sm font-medium text-gray-600">{label}</div>
          </div>
        )
      )}
    </div>
  );
};

export default StatisticsCards;
